import { Stack, Typography, Button } from "@mui/material";
import IconLoader from "@/features/Common/components/IconLoader";

interface InfoCardProps {
  handleTrigger: () => void;
  title: string;
  description: string;
}

export default function InfoCard({
  handleTrigger,
  title,
  description,
}: InfoCardProps) {
  return (
    <Stack width="100%" mt={2}>
      <Stack
        flexDirection="row"
        alignItems="center"
        justifyContent="space-between"
      >
        <Typography
          fontWeight={600}
          variant="h3"
          sx={{
            fontWeight: 700,
            fontSize: 26,
            lineHeight: 1.25,
          }}
        >
          {title}
        </Typography>
        <Button
          variant="text"
          onClick={() => handleTrigger()}
          style={{
            padding: 0,
            margin: 0,
            minWidth: "auto",
          }}
        >
          <IconLoader icon="InfoIcon" color="primary" />
        </Button>
      </Stack>
      <Stack mt={1}>
        <Typography
          sx={{
            fontSize: 16,
            fontWeight: 500,
            lineHeight: 1.5,
            color: "neutral.700",
          }}
        >
          {description}
        </Typography>
      </Stack>
    </Stack>
  );
}
